import { useNotificationListProps } from "@/pages/notification-list/fetch";
import { NotificationListPageUi } from "./ui";

export const NotificationListPage = () => {
  const {
    page,
    perPage,
    unreadOnly,
    setUnreadOnly,
    loadableNotifications,
    loadableOfferCargos,
    readNotification,
    readAllNotifications,
  } = useNotificationListProps();

  return (
    <NotificationListPageUi
      page={page}
      perPage={perPage}
      loadableNotifications={loadableNotifications}
      loadableOfferCargos={loadableOfferCargos}
      unreadOnly={unreadOnly}
      setUnreadOnly={setUnreadOnly}
      readNotification={readNotification}
      readAllNotifications={readAllNotifications}
    />
  );
};
